export default {
    computed: {
        lessonExamList() {
            return this.$store.state.lessonExamList
        },
        lessonExamListIndex: {
            get() {
                return this.$store.state.lessonExamListIndex
            },
            set(val) {
                this.$store.commit('lessonExamListIndex', val)
            }
        },
        examId() {
            return this.$store.state.exam.examId
        },
        examTimeEndId: {
            get() {
                return this.$store.state.exam.examTimeEndId
            },
            set(val) {
                this.$store.commit('exam/examTimeEndId', val)
            }
        },
        question() {
            let lessonExam = this.$store.state.lessonExam
            return lessonExam && lessonExam.QuestionModel ?
                lessonExam.QuestionModel[this.examId] :
                null
        },
        vocabularyModel() {
            return this.question.VocabularyModel
        },
        optionModel() {
            return this.question.OptionModel
        },
        examTotal() {
            return this.$store.state.lessonExam.QuestionModel.length
        },
        isExamEnd() {
            return this.examTotal === this.examId + 1 ? true : false
        },
        oNum() {
            return this.$store.state.exam.oNum
        },
        timeing: {
            get() {
                return this.$store.state.exam.timeing
            },
            set(val) {
                this.$store.commit('exam/timeing', val)
            }
        },
        timerId: {
            get() {
                return this.$store.state.exam.timerId
            },
            set(val) {
                this.$store.commit('exam/timerId', val)
            }
        }
    },
    methods: {
        startExam() {
            this.$store.commit('exam/startExam')
        },
        nextExam() {
            this.$store.commit('exam/nextExam')
        },
        timeEndExam() {
            this.$store.commit('exam/timeEndExam')
        },
        endExam() {
            this.$store.commit('exam/endExam')
        },
        addoNum(val) {
            this.$store.commit('exam/addoNum', val)
        }
    }
}



// WEBPACK FOOTER //
// ./src/delegate/examDelegate.js